import { Pessoa } from './Pessoa.js';

export class Fornecedor {
  constructor(data = {}) {
    this.id = data.id ?? 0;
    this.pessoaId = data.pessoaId ?? 0;
    this.pessoa = data.pessoa instanceof Pessoa
      ? data.pessoa
      : new Pessoa(data.pessoa ?? data);
    this.dataCad = data.dataCad ?? new Date().toISOString();
  }

  validarCliente() {
    if (this.pessoa?.fisica != null) {
      this.pessoa.fisica.validarCpf?.();
    }

    if (this.pessoa?.juridica != null) {
      this.pessoa.juridica.validarCnpj?.();
    }

    return true;
  }

  ValidarCliente() {
    return this.validarCliente();
  }
}

